(function() {
  'use strict';

  function initProductVideosAccordion() {
    const accordionSection = document.querySelector('.product-videos-accordion[data-videos-section]');
    
    if (!accordionSection) return;

    const accordionItems = accordionSection.querySelectorAll('.product-videos-accordion-item');
    const videoListItems = accordionSection.querySelectorAll('.product-videos-list-item');
    const videoEmbeds = accordionSection.querySelectorAll('.product-videos-embed');

    // Initialize active titles for each accordion
    accordionItems.forEach(accordionItem => {
      const firstVideoItem = accordionItem.querySelector('.product-videos-list-item--active');
      const activeTitle = accordionItem.querySelector('.product-videos-active-title');
      if (firstVideoItem && activeTitle) {
        const firstVideoTitle = firstVideoItem.querySelector('.product-videos-list-item-title');
        if (firstVideoTitle) {
          activeTitle.textContent = firstVideoTitle.textContent;
        }
      }
    });

    // Only allow one accordion item open at a time
    accordionItems.forEach(item => {
      item.addEventListener('toggle', function() {
        if (this.open) {
          // Close all other items
          accordionItems.forEach(otherItem => {
            if (otherItem !== this && otherItem.open) {
              otherItem.open = false;
            }
          });

          // Reset to first video when accordion opens
          const accordionId = this.dataset.accordionId;
          const embedWrapper = this.querySelector('.product-videos-embed');
          const firstVideoItem = this.querySelector('.product-videos-list-item');
          
          if (embedWrapper && firstVideoItem) {
            // Reset active state
            const allItems = this.querySelectorAll('.product-videos-list-item');
            allItems.forEach(btn => btn.classList.remove('product-videos-list-item--active'));
            firstVideoItem.classList.add('product-videos-list-item--active');
            
            // Update mobile active title
            const activeTitle = this.querySelector('.product-videos-active-title');
            const firstVideoTitle = firstVideoItem.querySelector('.product-videos-list-item-title');
            if (activeTitle && firstVideoTitle) {
              activeTitle.textContent = firstVideoTitle.textContent;
            }
            
            // Reset embed to first video
            const firstVideoId = firstVideoItem.dataset.videoId;
            const firstVideoType = firstVideoItem.dataset.videoType;
            const firstVideoIndex = firstVideoItem.dataset.videoIndex;
            const firstVideoItemId = firstVideoItem.dataset.videoItemId;
            const firstVideoFileUrl = firstVideoItem.dataset.videoFileUrl || '';
            
            if (firstVideoId && firstVideoType) {
              loadVideoInEmbed(embedWrapper, firstVideoId, firstVideoType, firstVideoItemId, accordionId, firstVideoFileUrl, firstVideoIndex);
            }
          }
        }
      });
    });

    // Handle video list item clicks
    videoListItems.forEach(item => {
      item.addEventListener('click', function() {
        const accordionId = this.dataset.accordionId;
        const videoId = this.dataset.videoId;
        const videoType = this.dataset.videoType;
        const videoIndex = this.dataset.videoIndex;
        const videoItemId = this.dataset.videoItemId;
        
        if (!videoId || !videoType) return;

        // Find the parent accordion item
        const accordionItem = this.closest('.product-videos-accordion-item');
        if (!accordionItem) return;

        // Update active state
        const allItems = accordionItem.querySelectorAll('.product-videos-list-item');
        allItems.forEach(btn => btn.classList.remove('product-videos-list-item--active'));
        this.classList.add('product-videos-list-item--active');

        // Find the embed wrapper in the same accordion
        const embedWrapper = accordionItem.querySelector('.product-videos-embed');
        if (!embedWrapper) return;

        // Update mobile active title
        const activeTitle = accordionItem.querySelector('.product-videos-active-title');
        const videoTitle = this.querySelector('.product-videos-list-item-title');
        if (activeTitle && videoTitle) {
          activeTitle.textContent = videoTitle.textContent;
        }

        // Get video file URL if it's a file type
        const videoFileUrl = this.dataset.videoFileUrl || '';

        // Load the selected video
        loadVideoInEmbed(embedWrapper, videoId, videoType, videoItemId, accordionId, videoFileUrl, videoIndex);
      });
    });
  }

  function loadVideoInEmbed(embedWrapper, videoId, videoType, videoItemId, accordionId, videoFileUrl, videoIndex) {
    // Pause all media first
    if (window.pauseAllMedia) {
      window.pauseAllMedia();
    }

    // Remove existing deferred-media
    const existingMedia = embedWrapper.querySelector('deferred-media');
    if (existingMedia) {
      existingMedia.remove();
    }

    // Create new deferred-media element
    const deferredMedia = document.createElement('deferred-media');
    deferredMedia.className = 'product-videos-embed-media deferred-media no-js-hidden';
    deferredMedia.setAttribute('data-media-id', videoId);
    deferredMedia.setAttribute('data-video-type', videoType);
    deferredMedia.setAttribute('data-observer', `product-videos--${accordionId}`);
    if (videoItemId) {
      deferredMedia.id = videoItemId;
    }
    if (videoType === 'file' && videoFileUrl) {
      deferredMedia.setAttribute('data-video-file-url', videoFileUrl);
    }

    // Create template with video embed
    const template = document.createElement('template');
    
    let videoHTML = '';
    if (videoType === 'youtube') {
      videoHTML = `<iframe 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen="" 
        frameborder="0" 
        height="315" 
        src="https://www.youtube.com/embed/${videoId}?enablejsapi=1&amp;autoplay=0&amp;mute=0&amp;controls=1&amp;modestbranding=1&amp;playsinline=1&amp;rel=0" 
        title="YouTube video player" 
        width="560"
      ></iframe>`;
    } else if (videoType === 'vimeo') {
      videoHTML = `<iframe 
        allow="autoplay; fullscreen; picture-in-picture" 
        allowfullscreen="" 
        frameborder="0" 
        height="480" 
        src="https://player.vimeo.com/video/${videoId}?autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0&amp;muted=0&amp;controls=1&amp;keyboard=1&amp;playsinline=1&amp;pip=0" 
        width="640"
      ></iframe>`;
    } else if (videoType === 'file') {
      // For file videos, find the template in the accordion and clone it
      const accordionItem = embedWrapper.closest('.product-videos-accordion-item');
      if (accordionItem && videoIndex) {
        const templateContainer = accordionItem.querySelector('.product-videos-file-templates');
        if (templateContainer) {
          const template = templateContainer.querySelector(`template[data-video-index="${videoIndex}"]`);
          if (template) {
            // Clone the template content
            const clonedContent = template.content.cloneNode(true);
            const videoElement = clonedContent.querySelector('video');
            if (videoElement) {
              videoHTML = videoElement.outerHTML;
            }
          }
        }
      }
      
      // Fallback: try to use videoFileUrl if available
      if (!videoHTML) {
        let fileUrl = videoFileUrl;
        if (!fileUrl) {
          const clickedButton = document.querySelector(`[data-video-item-id="${videoItemId}"]`);
          fileUrl = clickedButton?.dataset.videoFileUrl;
        }
        if (fileUrl) {
          videoHTML = `<video controls playsinline preload="metadata">
            <source src="${fileUrl}" type="video/mp4">
          </video>`;
        }
      }
    }

    template.innerHTML = videoHTML;
    deferredMedia.appendChild(template);

    // Append to embed wrapper
    embedWrapper.appendChild(deferredMedia);

    // Update active video index
    embedWrapper.setAttribute('data-active-video-index', videoIndex || '1');

    // Load the content immediately (don't wait for intersection observer)
    if (deferredMedia.loadContent) {
      deferredMedia.loadContent(false);
    } else {
      // Fallback: manually load if loadContent method doesn't exist yet
      setTimeout(() => {
        if (deferredMedia.loadContent) {
          deferredMedia.loadContent(false);
        } else {
          // Direct load if deferred-media hasn't initialized
          const templateContent = deferredMedia.querySelector('template');
          if (templateContent) {
            const content = document.createElement('div');
            const clonedNode = templateContent.content.firstElementChild.cloneNode(true);
            content.appendChild(clonedNode);
            deferredMedia.setAttribute('loaded', 'true');
            deferredMedia.appendChild(clonedNode);
          }
        }
      }, 100);
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductVideosAccordion);
  } else {
    initProductVideosAccordion();
  }

  // Re-initialize for dynamic content (e.g., theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initProductVideosAccordion);
    document.addEventListener('shopify:section:reorder', initProductVideosAccordion);
  }
})();
